import { User } from './user';
import { AccessGroup } from './accessGroup.model';
import { AuthorizerUser } from './authorizerUser';
import { Residence } from './residence';
import { Company } from './company';
import { Blockade } from './blockade';

export class Authorization {
    id: number;
    role: string;
    canAllowVisitors: boolean;
    sendInvitePassword: boolean;
    ownerUser: User;
    authorizedByUser: AuthorizerUser;
    performedByUserId: number;
    performedByUserName: string;
    validPeriodStartsAt: string;
    validPeriodEndsAt: string;
    waitOnLobby: boolean;
    singleAccess: boolean;
    accessGroups: AccessGroup[];
    intercomNumber: string;
    employeeId: string;
    phoneNumber: string;
    emailAddress: string;
    residenceId: number;
    companyId: number;
    unit: string;
    comments: string = '';
    status: AuthStatus;
    serviceProviderCompany: string;
    currentBlockade: Blockade;
    residence: Residence;
    company: Company;
    roleSubTypeId: number;
}

export enum AuthStatus
{
    Authorized,
    WaitingAuthorization,
    Confirmed,
    WaitingConfirmation,
    Refused,
    Canceled
}

export enum AuthStates {
    WaitingUpdate = 0,
    Ok = 1,
    Fail = 2
  }
